import React, { useState, useEffect, useCallback, useRef } from 'react';
import { IndicatorsSvg, StarSvg } from '../../components/WhatMakesSvg';
import firstSvg from '../../assets/images/our-health/svg/first.svg'
import secondSvg from '../../assets/images/our-health/svg/second.svg'
import thirdSvg from '../../assets/images/our-health/svg/third.svg'

const OurHealth = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [viewportWidth, setViewportWidth] = useState(0);
    const scrollContainer = useRef(null);

    const blogsData = [
        {
            image: firstSvg,
            author: 'Gulniesa Banu',
            description: '"Thank you for your incredible support during a challenging time. Your assistance was invaluable, Priyanka — you made a significant difference. I truly appreciate everything you did for me."',
            borderColor: 'border-[#00B7F0]',
            starCount: 5
        },
        {
            image: secondSvg,
            author: 'Nilesh Vithalbhai Varia',
            description: '"I appreciate the conversation we had. The detailed information you provided was immensely helpful. Thank you for your excellent support."',
            borderColor: 'border-[#FB7C2F]',
            starCount: 4
        },
        {
            image: thirdSvg,
            author: 'Tarush Jain',
            description: `"The conversation didn't feel like just any customer service interaction. Aaliya was incredibly helpful and listened to what I needed. Your service has been fantastic, and l am delighted."`,
            borderColor: 'border-[#3D823F]',
            starCount: 3
        },
        // {
        //     image: firstSvg,
        //     author: 'Gulniesa Banu',
        //     description: '"Thank you for your incredible support during a challenging time. Your assistance was invaluable, Priyanka — you made a significant difference. I truly appreciate everything you did for me."',
        //     borderColor: 'border-[#00B7F0]',
        //     starCount: 4
        // },
        // {
        //     image: secondSvg,
        //     author: 'Nilesh Vithalbhai Varia',
        //     description: '"I appreciate the conversation we had. The detailed information you provided was immensely helpful. Thank you for your excellent support."',
        //     borderColor: 'border-[#FB7C2F]',
        //     starCount: 4
        // },
        // {
        //     image: thirdSvg,
        //     author: 'Tarush Jain',
        //     description: `"The conversation didn't feel like just any customer service interaction. Aaliya was incredibly helpful and listened to what I needed. Your service has been fantastic, and l am delighted."`,
        //     borderColor: 'border-[#3D823F]',
        //     starCount: 4
        // },
        // {
        //     image: firstSvg,
        //     author: 'Gulniesa Banu',
        //     description: '"Thank you for your incredible support during a challenging time. Your assistance was invaluable, Priyanka — you made a significant difference. I truly appreciate everything you did for me."',
        //     borderColor: 'border-[#00B7F0]',
        //     starCount: 4
        // },
        // {
        //     image: secondSvg,
        //     author: 'Nilesh Vithalbhai Varia',
        //     description: '"I appreciate the conversation we had. The detailed information you provided was immensely helpful. Thank you for your excellent support."',
        //     borderColor: 'border-[#FB7C2F]',
        //     starCount: 4
        // },
    ];

    const getCardsPerView = useCallback(() => {
        if (viewportWidth < 640) return 1; // Mobile
        if (viewportWidth < 1024) return 2; // Tablet
        return 3; // Desktop
    }, [viewportWidth]);

    useEffect(() => {
        const handleResize = () => {
            setViewportWidth(window.innerWidth);
        };

        handleResize(); // Set initial width
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const scroll = useCallback((direction) => {
        const { current } = scrollContainer;
        if (current) {
            const cardsPerView = getCardsPerView();
            const containerWidth = current.offsetWidth;
            const cardWidth = containerWidth / cardsPerView;
            const scrollAmount = direction === 'left' ? -cardWidth : cardWidth;

            let newScrollLeft = current.scrollLeft + scrollAmount;
            const maxScrollLeft = current.scrollWidth - containerWidth;

            if (newScrollLeft < 0) newScrollLeft = maxScrollLeft;
            if (newScrollLeft > maxScrollLeft) newScrollLeft = 0;

            current.scrollTo({
                left: newScrollLeft,
                behavior: 'smooth'
            });

            const newIndex = Math.round(newScrollLeft / cardWidth);
            setActiveIndex(newIndex % blogsData.length);
        }
    }, [getCardsPerView, blogsData.length]);

    const handleScroll = useCallback(() => {
        const { current } = scrollContainer;
        if (current) {
            const cardWidth = current.offsetWidth / getCardsPerView();
            const newIndex = Math.round(current.scrollLeft / cardWidth);
            setActiveIndex(newIndex % blogsData.length);
        }
    }, [getCardsPerView, blogsData.length]);

    useEffect(() => {
        const { current } = scrollContainer;
        if (current) {
            current.addEventListener('scroll', handleScroll);
            return () => current.removeEventListener('scroll', handleScroll);
        }
    }, [handleScroll]);

    const cardsPerView = getCardsPerView();
    const totalSlides = Math.ceil(blogsData.length / cardsPerView);

    return (
        <div className="px-4 md:px-6 lg:px-[120px] pb-20 lg:pb-[120px] w-full relative">
            <h1 className="text-3xl md:text-[40px] leading-tight md:leading-[54px] font-semibold text-center mb-6 lg:mb-10 text-[#27506E]">
                Our Healthy Happy Faces
            </h1>
            <div
                className="relative overflow-hidden"
                role="region"
                aria-roledescription="carousel"
                aria-label="Our Healthy Happy Faces"
            >
                <div
                    ref={scrollContainer}
                    className="flex overflow-x-auto space-x-4 no-scrollbar scroll-smooth"
                    style={{
                        scrollSnapType: 'x mandatory',
                        scrollBehavior: 'smooth',
                        WebkitOverflowScrolling: 'touch',
                    }}
                >
                    {blogsData.map((blog, index) => (
                        <div
                            key={index}
                            className={`flex-shrink-0 p-4`}
                            style={{
                                width: `calc(${100 / cardsPerView}% - ${(cardsPerView - 1) * 16 / cardsPerView}px)`,
                                scrollSnapAlign: 'center'
                            }}
                            role="group"
                            aria-roledescription="slide"
                            aria-label={`${index + 1} of ${blogsData.length}`}
                        >
                            <div className={`border rounded-[32px] p-4 md:p-6 bg-white h-full ${blog.borderColor}`}>
                                <div className="flex items-center gap-4 mb-4">
                                    <img
                                        src={blog.image}
                                        alt={`${blog.author}'s avatar`}
                                        className="w-[50px] h-[50px] object-cover rounded-xl"
                                    />
                                    <div className='flex flex-col gap-2'>
                                        <p className='text-black text-xl leading-[23px] font-medium'>{blog.author}</p>
                                        <div className='flex flex-row gap-[7px]'>
                                            {[...Array(5)].map((_, index) => (
                                                <StarSvg key={index} fill={index < blog.starCount ? '#FFD600' : '#F3F3F3'} />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <p className="text-black text-sm leading-[22px] font-normal opacity-60">
                                    {blog.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className='flex md:hidden flex-row items-center justify-center gap-2 mt-6'>
                {[...Array(totalSlides)].map((_, i) => (
                    <button
                        key={i}
                        onClick={() => {
                            const { current } = scrollContainer;
                            if (current) {
                                const cardWidth = current.offsetWidth / cardsPerView;
                                current.scrollTo({
                                    left: i * cardsPerView * cardWidth,
                                    behavior: 'smooth'
                                });
                            }
                        }}
                        aria-label={`Go to slide ${i + 1}`}
                        aria-current={i === Math.floor(activeIndex / cardsPerView) ? "true" : "false"}
                    >
                        <IndicatorsSvg
                            fill={i === Math.floor(activeIndex / cardsPerView) ? '#0B497A' : '#CEDBE4'}
                        />
                    </button>
                ))}
            </div>
        </div>
    );
};

export default OurHealth;